// Tags
export const INFRA = 'Infrastructure';
export const NFT = 'NFT';
export const UTILITIES = 'Utilities';
export const DAPPS = 'DApps';
export const EXCHANGES = 'Exchanges';

export const WALLET = 'Wallet';
export const BRIDGES = 'Bridges';

export const DEFI = 'DeFi';
export const ORACLE = 'Oracle';
export const GAMEFI = 'GameFi';
export const LENDING = 'Lending';
export const STABLECOINS = 'Stablecoins';
export const MEMECOINS = 'Meme Coins';
export const SOCIAL = 'Social';
export const LAUNCHPAD = 'Launchpad';

export const MARKETPLACES = 'Marketplaces';
export const COLLECTIBLES = 'Collectibles';
export const NATIVE_NFT = 'Native NFT';
export const FORK_NFT = 'Fork NFT';
export const P2E = 'P2E';

export const DEV_TOOLING = 'Dev Tooling';
export const PAYMENTS = 'Payments';
export const SERVICES = 'Services';
export const METAVERSE = 'Metaverse';

// Filters
export const CATEGORIES = [INFRA, DAPPS, NFT, METAVERSE, UTILITIES];
export const BUCKETS = {
    [INFRA]: [INFRA, WALLET, BRIDGES, ORACLE],
    [DAPPS]: [DAPPS, DEFI, GAMEFI, EXCHANGES, LENDING, LAUNCHPAD, STABLECOINS, SOCIAL, MEMECOINS],
    [NFT]: [NFT, NATIVE_NFT, FORK_NFT, MARKETPLACES, COLLECTIBLES, P2E],
    [METAVERSE]: [METAVERSE],
    [UTILITIES]: [UTILITIES, DEV_TOOLING, PAYMENTS, SERVICES],
};

// Chains
export const ETHW = 'ETHW';
export const ETC = 'ETC';
export const ETF = 'ETHF';
export const ETH = 'ETH';
export const DEFAULT_CHAIN = ETHW;

export const CHAINS = [ETHW, ETC, ETF];

export const CHAIN_DATA = {
    [ETHW]: {
        name: 'EthereumPoW',
        coingeckoTokenId: 'ethereum-pow-iou',
        twitterLink: 'https://twitter.com/EthereumPoW',
    },
    [ETC]: {
        name: 'Ethereum Classic',
        coingeckoTokenId: 'ethereum-classic',
        twitterLink: 'https://twitter.com/eth_classic',
    },
    [ETF]: {
        name: 'EthereumFair',
        coingeckoTokenId: 'ethereumfair',
        twitterLink: 'https://twitter.com/EthereumFair',
    },
    // [ETD]: {
    //     name: 'EtherDAO',
    //     coingeckoTokenId: 'ethereum',
    //     twitterLink: 'https://twitter.com/etherdao__',
    // },
    [ETH]: {
        name: 'Ethereum',
        coingeckoTokenId: 'ethereum',
        twitterLink: 'https://twitter.com/ethereum',
    },
};

export const ETH_COINGECKO_ID = 'ethereum';

// LINKS
export const DAPP = 'DApp';
export const DISCORD = 'Discord';
export const FACEBOOK = 'Facebook';
export const GITHUB = 'GitHub';
export const INSTAGRAM = 'Instagram';
export const MEDIUM = 'Medium';
export const TELEGRAM = 'Telegram';
export const TWITTER = 'Twitter';
export const WEBSITE = 'Website';

export const LINKS = [WEBSITE, TWITTER, INSTAGRAM, FACEBOOK, MEDIUM, TELEGRAM, DISCORD, GITHUB];
